<h2 mat-dialog-title>Confirm Action</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">{{ data.cancelButtonText || 'No' }}</button>
  <button mat-button color="primary" (click)="onYesClick()">{{ data.confirmButtonText || 'Yes' }}</button>
</mat-dialog-actions>